import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import envvars from './envvars';

const DEFAULT_BEACON = 'bam.nr-data.net';

const initNewRelic = () => {
  const {
    newRelicAccountId,
    newRelicApplicationId,
    newRelicLicenseKey,
  } = envvars;

  if (!newRelicAccountId || !newRelicApplicationId || !newRelicLicenseKey) {
    return;
  }

  new BrowserAgent({
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: [DEFAULT_BEACON] },
    },
    info: {
      beacon: DEFAULT_BEACON,
      errorBeacon: DEFAULT_BEACON,
      licenseKey: newRelicLicenseKey,
      applicationID: newRelicApplicationId,
      sa: 1,
    },
    loader_config: {
      accountID: newRelicAccountId,
      trustKey: newRelicAccountId,
      agentID: newRelicApplicationId,
      licenseKey: newRelicLicenseKey,
      applicationID: newRelicApplicationId,
    },
  });
};

initNewRelic();
